import { Box } from "@mui/material";
import SectionCard from "./SectionCard";
import CodeEditorPanel from "./CodeEditorPanel";

/**
 * Sized so the Code card's overall height lines up with the General and
 * Labels cards stacked in the column beside it.
 */
const CODE_EDITOR_HEIGHT = "430px";

interface Props {
  html: string;
  css: string;
  onHtmlChange: (value: string) => void;
  onCssChange: (value: string) => void;
  onFormatHtml: () => void;
  onFormatCss: () => void;
  /** Locked while a save is in progress. */
  disabled?: boolean;
}

const CodeCard = ({
  html,
  css,
  onHtmlChange,
  onCssChange,
  onFormatHtml,
  onFormatCss,
  disabled = false,
}: Props) => (
  <SectionCard title="Code">
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: 2.5,
      }}
    >
      <CodeEditorPanel
        label="HTML"
        mode="html"
        value={html}
        onChange={onHtmlChange}
        height={CODE_EDITOR_HEIGHT}
        readOnly={disabled}
        onFormat={onFormatHtml}
        formatDisabled={!html || disabled}
      />
      <CodeEditorPanel
        label="CSS"
        mode="css"
        value={css}
        onChange={onCssChange}
        height={CODE_EDITOR_HEIGHT}
        readOnly={disabled}
        onFormat={onFormatCss}
        formatDisabled={!css || disabled}
      />
    </Box>
  </SectionCard>
);

export default CodeCard;
